import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const SCHEDULE_SCHEMA = Object.freeze({
  DOC_NUMBER: '',
});
const RECORD = generateSchema(SCHEDULE_SCHEMA);
const KEYS: any = generateKeys(SCHEDULE_SCHEMA);

export class Sortable extends Record(RECORD) {
  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get docNumber(): number {
    return this.get(KEYS.DOC_NUMBER);
  }
}
